// src/auth.js

import { getAuth } from "firebase/auth";
import app from "../firebaseConfig"; // Default import of 'app'

// Initialize Firebase Authentication
const auth = getAuth(app);

export default auth; 
